<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="images" />
          Popup banner
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('upcoming')"></b-tab>
          <b-tab :title="$t('activating')"></b-tab>
          <b-tab :title="$t('finished')"></b-tab>
          <b-tab :title="$t('blocked')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{$t('search')}}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus" />&nbsp;{{$t('create')}}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{$t('found', [itemCount])}}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-1"></div>
            <div class="col-lg-6">Popup</div>
            <div class="col-lg-4">{{$t('info')}}</div>
            <div class="col-lg-1"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-1">
              <a :href="item.image" target="_blank">
                <figure  class="c-board-table__avatar">
                  <img :src="item.image" class="thumbnail" alt="..." />
                </figure>
              </a>
            </div>
            <div class="col-lg-6">
              <div>
                <b>{{$t('title')}}: </b>
                <a style="color: black; font-size: 1.1em" :href="item.link" target="_blank"><span>{{item.title}}</span></a>
              </div>
              <div class="mt-1">
                <b>{{$t('desc')}}: </b>
                <span>{{item.desc}}</span>
              </div>
              <div>
                <span v-if="item.type ===  'self'" class="badge badge-primary">{{$t('self')}}</span>
                <span v-else class="badge badge-secondary">{{$t('blank')}}</span>
              </div>
            </div>
            <div class="col-lg-4">
              <p v-if="item.updatedBy">
                <b>{{$t('updateTime')}}: </b>
                <span>{{item.updateTime | moment('DD/MM/YY HH:mm')}}</span>
              </p>
              <p v-if="item.updatedBy">
                <b>{{$t('updatedBy')}}: </b>
                <span>{{item.updatedBy.name}}</span>
              </p>
              <p>
                <b>{{$t('maxNumberUse')}}: </b>
                <span>{{item.maxNumberUse}}</span>&nbsp;
                <span v-if="item.maxNumberUse > 1">| {{$t('againAfter')}} {{timeOptions.find(op =>  op.value === item.againAfter).text}}</span>
              </p>
              <div>
                <b>{{$t('showTime')}}: </b>
                <span>{{item.startTime | moment('DD/MM/YY HH:mm')}} - {{item.endTime | moment('DD/MM/YY HH:mm')}}</span>
              </div>
              <div class="mt-1">
                <span v-if="item.isAuth" class="badge badge-danger mr-1">{{$t('isAuth')}}</span>
                <span v-if="!item.active" class="badge badge-danger mr-1">{{$t('blocked')}}</span>

                <span v-else-if="item.startTime > Date.now() && item.endTime > Date.now()" class="badge badge-warning">{{$t('upcoming')}}</span>
                <span v-else-if="item.startTime < Date.now() && item.endTime > Date.now()" class="badge badge-info">{{$t('activating')}}</span>
                <span v-else-if="item.startTime < Date.now() && item.endTime < Date.now()" class="badge badge-success">{{$t('finished')}}</span>
              </div>
            </div>
            <div class="col-lg-1">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit" />&nbsp;{{$t('edit')}}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash" />&nbsp;{{$t('delete')}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{$t('notFoundCreate')}}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{$t('notFoundSearch')}}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{$t('found', [itemCount])}}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" size="lg" @ok="savePopup" no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col-md-7">
          <form-input :label="$t('title')" :model="formModel" attribute="title" :errors="formErrors"></form-input>
          <form-textarea :row="4" :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-textarea>
          <form-file :label="$t('image')" service="/upload/upload-image" :model="formModel" attribute="fileHash" :errors="formErrors" accept="image/jpeg,image/jpg,image/png" />
          <form-input :label="$t('link')" :model="formModel" attribute="link" placeholder="https://callio.vn/" :errors="formErrors"></form-input>
          <form-select :label="$t('type')" :model="formModel" attribute="type" :errors="formErrors" :options="[
                    // {value: null, text: $t('chooseType')},
                    {value: 'self', text: $t('self')},
                    {value: 'blank', text: $t('blank')},
                ]"></form-select>
          <form-checkbox :chk-label="$t('isAuth')" :model="formModel" attribute="isAuth" :errors="formErrors"></form-checkbox>
          <form-checkbox :chk-label="$t('active')" :model="formModel" attribute="active" :errors="formErrors"></form-checkbox>
        </div>
        <div class="col-md-5">
          <form-date-time :label="$t('startTime')" :model="formModel" attribute="startTime" format="DD/MM/YY HH:mm:ss" :errors="formErrors"></form-date-time>
          <form-date-time :label="$t('endTime')" :model="formModel" attribute="endTime" format="DD/MM/YY HH:mm:ss" :errors="formErrors"></form-date-time>
          <form-input :label="$t('maxNumberUse')" :model="formModel" attribute="maxNumberUse" :errors="formErrors"></form-input>
          <form-select v-if="formModel.maxNumberUse > 1" :label="$t('againAfter')" :model="formModel" attribute="againAfter" :options="timeOptions" :errors="formErrors"></form-select>
        </div>
      </div>
    </b-modal>
  </main>
</template>
<script>
import List from '../mixins/List';
import CRUD from "../mixins/CRUD";
export default {
  mixins: [List, CRUD],
  data: function() {
    return {
      service: '/admin-popup',
      defaultFormModel: {
        maxNumberUse: 1,
        againAfter: 60 * 1000,
        type: 'blank',
        active: true,
        isAuth: false
      },
      defaultFilterFormModel: {
        keyword: null,
        category: null
      },
      autoLoad: true,
      timeOptions: [
        {value: 5 * 60 * 1000, text: this.$t('min', [5])},
        {value: 10 * 60 * 1000, text: this.$t('min', [10])},
        {value: 15 * 60 * 1000, text: this.$t('min', [15])},
        {value: 30 * 60 * 1000, text: this.$t('min', [30])},
        {value: 60 * 60 * 1000, text: this.$t('hr', [1])},
        {value: 120 * 60 * 1000, text: this.$t('hr', [2])},
        {value: 180 * 60 * 1000, text: this.$t('hr', [3])},
        {value: 240 * 60 * 1000, text: this.$t('hr', [4])},
        {value: 480 * 60 * 1000, text: this.$t('hr', [8])},
        {value: 1440 * 60 * 1000, text: this.$t('hr', [24])},
        {value: 2880 * 60 * 1000, text: this.$t('day', [2])},
        {value: 4320 * 60 * 1000, text: this.$t('day', [3])},
        {value: 5760 * 60 * 1000, text: this.$t('day', [4])},
        {value: 7200 * 60 * 1000, text: this.$t('day', [5])},
        {value: 14400 * 60 * 1000, text: this.$t('day', [10])},
        {value: 21600 * 60 * 1000, text: this.$t('day', [15])},
        {value: 43200 * 60 * 1000, text: this.$t('month', [1])},
        {value: 86400 * 60 * 1000, text: this.$t('month', [2])},
        {value: 129600 * 60 * 1000, text: this.$t('month', [3])},
      ],
    }
  },
  methods: {
    savePopup(evt) {
      if (typeof this.formModel.fileHash === 'object' && this.formModel.fileHash.length) {
        this.formModel.fileHash = this.formModel.fileHash[0].fileHash;
      }
      this.save(evt);
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Title',
        image: 'Image',
        startTime: 'Show from',
        endTime: 'Show to',
        maxNumberUse: 'Show count',
        againAfter: 'show again after',
        active: 'Active',
        min: '{0} minutes',
        hr: '{0} hours',
        day: '{0} days',
        month: '{0} months',
        setting: 'Setting',
        createdBy: 'Created by',
        updatedBy: 'Updated by',
        viewImage: 'View imaage',
        notActive: 'Not active',
        type: 'Open link in',
        self: 'Current window',
        blank: 'New window',
        upcoming: 'Upcoming',
        activating: 'Activating',
        finished: 'Finished',
        blocked: 'Blocked',
        showTime: 'Show time',
        link: 'Link',
        isAuth: "Shown only when logged in"
      },
      vi: {
        title: 'Tiêu đề',
        image: 'Hình ảnh',
        startTime: 'Hiển thị từ',
        endTime: 'Hiển thị đến',
        maxNumberUse: 'Số lần hiển thị',
        againAfter: 'hiển thị lại sau',
        active: 'Được hoạt động',
        min: '{0} phút',
        hr: '{0} giờ',
        day: '{0} ngày',
        month: '{0} tháng',
        setting: 'Cài đặt',
        createdBy: 'Tạo bởi',
        updatedBy: 'Cập nhật bởi',
        viewImage: 'Xem ảnh',
        notActive: 'Dừng hoạt động',
        type: 'Mở đường dẫn ở',
        self: 'Cửa sổ hiện tại',
        blank: 'Cửa sổ mới',
        upcoming: 'Sắp diễn ra',
        activating: 'Đang hoạt động',
        finished: 'Đã hoàn thành',
        blocked: 'Bị khoá',
        showTime: 'Thời gian hiển thị',
        link: 'Đường dẫn',
        isAuth: "Chỉ hiện khi đăng nhập"
      }
    }
  },
}
</script>

<style>
.c-board-table__avatar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #fff;
  border-radius: 50%;
}

.c-board-table__avatar img {
  width: auto;
  height: auto;
  min-height: 100%;
  min-width: 100%;
}
</style>
